<template>
    <div class="relative m-auto min-h-dvh">
        <div class="relative">
            <slot />
        </div>
        <Overview v-if="overviewStore.hasOverviewPageMounted && translations" :translations :search :menu :markers :data :cards />
        <LayoutFooter v-if="translations?.footer && !overviewStore.isOverviewPageActive" :sites :data="translations.footer" />
    </div>
</template>

<script setup lang="ts">
import { useIsPageLoading } from "@global/Composables/useIsPageLoading";
import { useFbTracking } from "@main/Composables/useFbTracking";
import { useI18nStore } from "@stores/i18nStore";
import { useOverviewStore } from "@stores/overview/overviewStore";
import { defineAsyncComponent } from "vue";

const Overview = defineAsyncComponent(() => import("@main/Pages/Overview/Overview.vue"));
const LayoutFooter = defineAsyncComponent(() => import("@main/Layouts/LayoutFooter.vue"));

defineProps<{
    data?: App.Data.Main.Overview.ViewModels.OverviewIndex;
    menu?: Domain.Shared.Data.MainMenuData;
    translations?: Domain.Shared.Data.Translations;
    sites?: Domain.Shared.Data.ValuePairData[];
    markers?: App.Http.Main.Overview.ViewModels.MapMarker[];
    search?: Domain.Overview.DataTransferObjects.SearchDTO;
    cards?: App.Data.Main.Overview.PaginatedBidderCardListData;
}>();

const overviewStore = useOverviewStore();

useIsPageLoading();
useFbTracking();
useI18nStore();
</script>
